import '.a6{position:absolute;}.ssr-plugin'
import '.d5{inset:0px;}.ssr-plugin'
import '.d6{object-fit:cover;}.ssr-plugin'
import '.a{width:100%;}.ssr-plugin'
import '.i{height:100%;}.ssr-plugin'
import '.c8{z-index:0;}.ssr-plugin'
import '.d7{height:80vh;}.ssr-plugin'
import '.d8{bottom:0px;}.ssr-plugin'
import '.ae{left:0px;}.ssr-plugin'
import '.cf{right:0px;}.ssr-plugin'
import '.d9{margin-bottom:32px;}.ssr-plugin'
import '.ap{position:relative;}.ssr-plugin'
import '.b4{opacity:0;}.ssr-plugin'
import '.da{animation:winner-title-slide-in 0.6s ease-out forwards;}.ssr-plugin'
import '.cp{max-width:480px;}.ssr-plugin'
import '.bn{opacity:0.5;}.ssr-plugin'
import { styled } from 'inlines'
import { Layout } from '../components/Layout.js'
import { useTrack } from '../hooks/useTrack.js'
import { AnalyticsEvent } from '../../../shared/analyticsEvents.js'
import { transparentColor } from '../utils/transparentcolor.js'
import { colors } from '../utils/colors.js'
import { TABLET, MOBILE } from '../utils/breakpoints.js'
import { useContentQuery } from '../ctx.js'
import { useEffect } from 'react'

export const WinnerPage = ({ title, description, contestants }) => {
  const track = useTrack('winner')

  const { data: winnerName } = useContentQuery('winner')

  const winnerContestant = contestants?.find(
    (c: { name: string }) => c.name === winnerName,
  )

  const winnerImage = winnerContestant?.image?.src

  useEffect(() => {
    track(AnalyticsEvent.PAGE_LOAD)
  }, [])

  return (
    <>
      {winnerImage && (
        <img className="a6 d5 d6 a i c8"
          src={winnerImage}
        />
      )}
      <div className="d7 a6 a d8 ae cf c8"
        style={{
          background: `linear-gradient(0deg, ${transparentColor(colors.secondary, 1)} 0%, ${transparentColor(colors.secondary, 0)} 100%)`,}}
      />
      <Layout
        style={{
          justifyContent: 'flex-end',
          position: 'relative',
          [TABLET]: {
            paddingBottom: '48px',
          },
          [MOBILE]: {
            padding: '16px',
            paddingBottom: '24px',
          },
        }}
      >
        <style>{`
          @keyframes winner-title-slide-in {
            from { opacity: 0; transform: translateY(48px); }
            to   { opacity: 1; transform: translateY(0); }
          }
        `}</style>

        <h3 className="d9 ap b4 da"
        >
          {title
            ?.replace('{{WINNER}}', winnerName ?? '')
            .replace('{{YEAR}}', '2026')}
        </h3>

        <p className="cp bn">
          {description}
        </p>
      </Layout>
    </>
  )
}
